import React, { useEffect } from "react";
import { Helmet } from "react-helmet";

import NavBar from "../components/common/navBar";
import Footer from "../components/common/footer";
import Logo from "../components/common/logo";

import INFO from "../data/user";
import SEO from "../data/seo";

import "./styles/producer.css";


const ReadArticle = () => {

	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	const currentSEO = SEO.find((item) => item.page === "producer");

	return (
		<React.Fragment>
			<Helmet>
				<title>{`Producer| ${INFO.main.title}`}</title>
				<meta name="description" content={currentSEO.description} />
				<meta
					name="keywords"
					content={currentSEO.keywords.join(", ")}
				/>
			</Helmet>

			<div className="page-content">
				<NavBar active="producer"/>

				<div className="content-wrapper">
					<div className="producer-logo-container">
						<div className="producer-logo">
							<Logo width={46} />
						</div>
					</div>

					<div className="producer-container">
						<div
							className="producer-hero"
							style={{ backgroundImage: "url('/images/producer/producer-hero.jpg')" }}
						>
							<div className="producer-hero-overlay">
								<h1 className="producer-hero-title">Production Work</h1>
							</div>
						</div>

						<div className="producer-projects">
							{INFO.producer.map((project, index) => (
								<div className="producer-project-card" key={index}>
									<h2 className="producer-project-title">{project.title}</h2>
									<h3 className="producer-project-details">{project.details}</h3>
									<p className="producer-project-description">{project.description}</p>
								</div>
							))}
						</div>
					</div>
					<div className="page-footer">
						<Footer />
					</div>
				</div>
			</div>
		</React.Fragment>
	);
};

export default ReadArticle;
